import { render, staticRenderFns } from "./MaterialConsumption.vue?vue&type=template&id=206ff80d&scoped=true"
import script from "./MaterialConsumption.vue?vue&type=script&lang=js"
export * from "./MaterialConsumption.vue?vue&type=script&lang=js"
import style0 from "./MaterialConsumption.vue?vue&type=style&index=0&id=206ff80d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ff80d",
  null
  
)

export default component.exports